import feature from 'feature.js';
import $ from "jquery";

function initFeatures() {

	/**
	 * Feature Detection Script
	 *
	 * @version 1.0.0
	 * @var feature
	 * @author Dominic Vogl <dominic.vogl@cat-ia.de>
	 */

	document.addEventListener("DOMContentLoaded", function() {

		// Check if Javascript is active, overwrite no-js class
		document.documentElement.className = "js";

		// add message
		console.info("%cThis site was build with love by " + "%c(https://www.riegg.com)" + " and " + "(https://dominicvogl.de)", "", "color: #2199e8; background-color: #000");

		// check if svg is available in this browser
		console.log(feature.svg);
		console.log(feature.historyAPI);

		// check touch support and render class to <html>
		if (feature.touch) {
			document.documentElement.className += " touch";
		} else {
			document.documentElement.className += " no-touch";
		}

	});

}

export default initFeatures;
